const COUNTRY_CODE = "254";
const NATIONAL_LENGTH = 9;

export const PHONE_PREFIX = `+${COUNTRY_CODE}`;

export function nationalDigits(raw: string): string {
  let digits = raw.replace(/\D/g, "");
  if (digits.startsWith(COUNTRY_CODE)) digits = digits.slice(COUNTRY_CODE.length);
  digits = digits.replace(/^0+/, "");
  return digits.slice(0, NATIONAL_LENGTH);
}

export function isValidNational(digits: string): boolean {
  return /^[17]\d{8}$/.test(digits);
}

export function toE164(digits: string): string {
  return `${PHONE_PREFIX}${digits}`;
}

export function formatNational(digits: string): string {
  return [digits.slice(0, 3), digits.slice(3, 6), digits.slice(6, 9)].filter(Boolean).join(" ");
}

export function formatE164(phone: string): string {
  return `${PHONE_PREFIX} ${formatNational(nationalDigits(phone))}`;
}
